import { render } from "./ManageLocations.vue?vue&type=template&id=05ba8231&scoped=true"
import script from "./ManageLocations.vue?vue&type=script&lang=js"
export * from "./ManageLocations.vue?vue&type=script&lang=js"

import "./ManageLocations.vue?vue&type=style&index=0&id=05ba8231&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ba8231"]])

export default __exports__